import React, { useEffect, useState } from "react";
import Style from "./CurrentOrder.module.css";
import { getCurrentOrderList } from "../../Api/BarestServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import CurrentOrderList from "../CurrentOrderList/CurrentOrderList";
import { separate } from "../../Seprate/Seprate";
import { errorToast } from "../../Toast/Toast";
import moment from "moment-jalaali";
import { Button } from "react-bootstrap";
import { Modal } from "antd";
import TransactionList from "../TransactionList/TransactionList";
const CurrentOrder = () => {
  const [currentOrderLists, setCurrentOrderLists] = useState([]);
  const [modalState, setModalState] = useState(false);
  const [transactionDataState, setTransactionDataState] = useState();
  useEffect(() => {
    GetOrdersData();
  }, []);
  const GetOrdersData = async () => {
    getCurrentOrderList((succ, res) => {
      if (succ) {
        if (res.status === "1") {
          errorToast("مشکلی پیش آمده است");
        } else {
          setCurrentOrderLists(calculateOrderTotals(res).orders);
        }
      } else {
        console.error(res);
      }
    });
  };
  function calculateOrderTotals(data) {
    if (!data.orders || !Array.isArray(data.orders)) {
      return data;
    }
    data.orders.forEach((order) => {
      let total = 0;
      order.suppliers.forEach((supplier) => {
        let sup_total = 0;
        supplier.products.forEach((product) => {
          const productTotal =
            parseFloat(product.price) * parseInt(product.count);
          sup_total += productTotal;
        });
        supplier.total = sup_total;
        total += sup_total;
      });
      //total += order.delivery_price;
      order.total = parseInt(total);
    });
    return data;
  }

  let timee = [];
  let loadingHolder = null;
  if (currentOrderLists === undefined)
    loadingHolder = (
      <div className={Style.SetLoading}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  else if (currentOrderLists.length === 0) {
    loadingHolder = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/not2.png" alt="سفارشات" />
        </div>
        {/* <p className={Style.NoOrderText}>سفارشی یافت نشد</p> */}
      </div>
    );
  } else {
    currentOrderLists.forEach((element) => {
      timee[element.id] = element.prepare_remaining_time;
    });
    loadingHolder = currentOrderLists.map((item, index) => {
      let sum = 0;
      return (
        <div key={index} className={Style.itemsHolder}>
          <Modal
            title="لیست تراکنشات"
            open={modalState}
            onCancel={() => setModalState(false)}
            destroyOnClose
            style={{ direction: "rtl" }}
            closeIcon={<></>}
            footer={
              <Button
                className={Style.closeModalButton}
                onClick={() => setModalState(false)}
              >
                بستن
              </Button>
            }
          >
            <TransactionList data={transactionDataState} />
          </Modal>
          <section className={Style.baseInfoHolder}>
            <div>
              <p>{`شماره سفارش: ${item.id}`}</p>
            </div>
            <div>
              <p style={{ direction: "ltr" }}>
                {" "}
                {moment.unix(parseInt(item.date)).format("jYYYY/jM/jD--hh:mm")}
              </p>
            </div>
          </section>
          {item.suppliers.map((val, count) => {
            sum = parseInt(val.total_price) + sum;
            return <CurrentOrderList item={item} key={count} data={val} />;
          })}
          <div className={Style.bottomPart}>
            <div className={Style.PriceHolder}>
              <h4>هزینه پیک</h4>
              <span style={{ color: "green" }}>
                {separate(parseInt(item.delivery_price))}
                <span>تومان</span>
              </span>
            </div>
          </div>
          <div className={Style.bottomPart}>
            <div className={Style.PriceHolder}>
              <h4>قیمت نهایی</h4>
              <span style={{ color: "green" }}>
                {separate(
                  item?.total +
                    parseInt(item.delivery_price) -
                    parseInt(item.discount_amount)
                )}
                <span>تومان</span>
              </span>
            </div>
          </div>
          <div className={Style.bottomPart}>
            <div className={Style.PriceHolder}>
              <h4>کد پیک:</h4>
              <span>{`${
                item.delivery_code ? item.delivery_code : null
              } `}</span>
            </div>
          </div>
          {item.deliver.length !== 0 ? (
            <div className={Style.bottomPart}>
              <div className={Style.PriceHolder}>
                <h4>اطلاعات پیک:</h4>
                <span>{`${item.deliver?.first_name} ${item.deliver?.last_name}`}</span>
              </div>
            </div>
          ) : null}
          {item.deliver.length !== 0 ? (
            <div className={Style.bottomPart}>
              <div className={Style.PriceHolder}>
                <h4>شماره تماس پیک:</h4>
                <a
                  href={`tel:${item.deliver?.phone}`}
                >{`${item.deliver?.phone}`}</a>
              </div>
            </div>
          ) : null}
          <div className={Style.bottomPart}>
            <div className={Style.PriceHolder}>
              <h4>تحویل گیرنده:</h4>
              <span>{`${item.first_name} ${item.last_name}`}</span>
            </div>
          </div>
          <div className={Style.bottomPart}>
            <div className={Style.PriceHolder}>
              <h4>آدرس انتخابی روی نقشه:</h4>
              <span>{item.address}</span>
            </div>
          </div>
          <div className={Style.bottomPart}>
            <div className={Style.PriceHolder}>
              <h4 style={{ color: "black" }}>آدرس نوشته شده شما :</h4>
              <a
                href={`https://maps.apple.com/?q=${item.lon},${item.lat}`}
                target="_blank"
                rel="noreferrer"
              >
                {`${item.city}، ${item.region}، ${item.street}، ${item.alley} ${
                  item.apartment_name && "، " + item.apartment_name
                }${
                  item.apartment_number !== "0"
                    ? "، " + item.apartment_number
                    : ""
                }`}
              </a>
            </div>
          </div>
          <Button
            className={Style.TransactionButton}
            onClick={() => {
              setModalState(true);
              setTransactionDataState(item.transactions);
            }}
          >
            تراکنشات سفارش
          </Button>
        </div>
      );
    });
  }
  return <div className={Style.OrderHolder}>{loadingHolder}</div>;
};

export default CurrentOrder;
